import { combineReducers } from "redux";

import * as ActionTypes from "./states";
import {SESSION_EXPIRED_LOADED, SESSION_LOADED, SESSION_UNLOADED} from "./states";
const initAccess = {
  hr: null,
  ba: null,
  mkbf:null
};

const initLevel = {
  hr: "",
  ba: "",
  mkbf:""
};

const initLoading = {
  setLoading: false,
};
const initSessionLoading ="";
const initDownload = false;
const initSessionExpiryLoading = false


const initClickLoading = {
  isClick: false,
};

export const access = (state = initAccess, action) => {
  switch (action.type) {
    case ActionTypes.ACCESS_LOADED: {
      return Object.assign({}, state, {
        hr: action.hrAccess,
        ba: action.baAccess,
        mkbf:action.mkbfAccess
      });
    }
    case ActionTypes.ACCESS_UNLOADED: {
      return Object.assign({}, state, {
        access: state,
      });
    }
    default:
      return state;
  }
};

export const session = (state=initSessionLoading,action)=>{
  switch (action.type) {
    case SESSION_LOADED:
      return action.sessionId
    case SESSION_UNLOADED:
      return action.sessionId
    default:
      return state;
  }
}

export const sessionExpiry = (state=initSessionExpiryLoading,action)=>{
  if(action.type === SESSION_EXPIRED_LOADED){
    return action.isExpired
  }else
    return state;
}

export const user = (state = initAccess, action) => {
  switch (action.type) {
    case ActionTypes.USER_LOADED: {
      return Object.assign({}, state, action.user);
    }
    case ActionTypes.USER_UNLOADED: {
      return Object.assign({}, state, {
        access: state,
      });
    }
    default:
      return state;
  }
};

export const level = (state = initLevel, action) => {
  switch (action.type) {
    case ActionTypes.LEVEL_LOADED: {
      return Object.assign({}, state, {
        hr: action.hrLevel,
        ba: action.baLevel,
        mkbf:action.mkbfLevel
      });
    }
    case ActionTypes.LEVEL_UNLOADED: {
      return Object.assign({}, state, {
        access: state,
      });
    }
    default:
      return state;
  }
};

export const loading = (state = initLoading, action) => {
  switch (action.type) {
    case ActionTypes.SET_LOADING: {
      return Object.assign({}, state,action.loading );
    }
    default:
      return state;
  }
};

export const download = (state = initDownload, action) => {
  switch (action.type) {
    case ActionTypes.START_DOWNLOAD: {
      return action.status;
    }
    default:
      return state;
  }
};

export const userClick = (state = initClickLoading, action) => {
  switch (action.type) {
    case ActionTypes.CLICK_LOADING: {
      return Object.assign({}, state, {
        isClick: action.value,
      });
    }
    default:
      return state;
  }
};

export const reducers = combineReducers({
  access: access,
  level: level,
  loading: loading,
  click: userClick,
  user: user,
  session:session,
  sessionExpiry:sessionExpiry,
  download:download
});
export default reducers;
